import { NavLink, Outlet } from "react-router-dom";
import { PageHeader } from "@/components/common/PageHeader";
import { cn } from "@/lib/utils";

const TABS = [
  ["users", "Users"], ["catalogue", "Catalogue"], ["import", "Import catalogue"], ["announcements", "Announcements"],
  ["feedback", "Feedback inbox"], ["activity", "Activity"], ["usage", "Usage"], ["webhooks", "Webhooks"], ["audit", "Audit log"], ["settings", "Settings"],
];

export default function AdminLayout() {
  return (
    <div data-testid="admin-page">
      <PageHeader title="Admin" description="People, catalogue and settings. Only Owners can see this area." />
      <nav className="-mx-1 mb-8 flex flex-wrap gap-x-1 border-b pb-px" aria-label="Admin sections">
        {TABS.map(([to, label]) => (
          <NavLink key={to} to={to} data-testid={`admin-tab-${to}`}
            className={({ isActive }) => cn("whitespace-nowrap border-b-2 px-3 py-2.5 text-sm transition-quick", isActive ? "border-action font-medium text-foreground" : "border-transparent text-muted-foreground hover:text-foreground")}>
            {label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
